import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (!this.element.dataset.added) {
      const event = new CustomEvent('notification:added', { bubbles: true, cancelable: true });
      this.element.dispatchEvent(event);
      this.element.dataset.added = 'true';
    }
  }
}
